<template>
  <div class="login-content">
    <el-form class="form" :model="vForm" ref="vForm">
      <el-form-item class="form-group" prop="mobile" :rules="{ validator: validator.mobile }">
        <el-input class="form-control" v-model="vForm.mobile" placeholder="手机号码" clearable></el-input>
      </el-form-item>
      <el-form-item class="form-group form-group-code" prop="code" :rules="validator.code">
        <el-input class="form-control" v-model="vForm.code" placeholder="短信验证码"></el-input>
        <el-button :disabled="codeTimer > 0" :loading="codeLoading" @click="sendCode" class="button-code" type="primary">
          <span v-if="codeTimer == 0">发送验证码</span>
          <span v-else>{{ codeTimer }}s后重发验证码</span>
        </el-button>
      </el-form-item>
      <div class="login-btn-box">
        <el-button @click="doSubmit" ref="submitBtn" class="login-btn" :loading="doSubmitLoading" type="primary">确认绑定</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import validator from '../validator';
export default {
  data() {
    return {
      validator,
      vForm: {
        mobile: '',
        code: '',
      },
      codeLoading: false,
      codeTimer: 0,
      codeTimerHandle: 0,
      doSubmitLoading: false,
    };
  },

  inject: ['redirectProject'],

  methods: {
    async sendCode() {
      this.codeLoading = true;
      try {
        await this.$refs.vForm.validateField('mobile');
        await this.api.message.sendSMSCode({ mobile: this.vForm.mobile });
        this.countDownTimer(300);
      } catch (e) {
        console.error(e);
      }
      this.codeLoading = false;
    },

    countDownTimer(codeTimer) {
      this.codeTimer = codeTimer || this.codeTimer;
      if (this.codeTimer > 0) {
        setTimeout(() => {
          this.codeTimer--;
          this.countDownTimer();
        }, 1000);
      }
    },

    async doSubmit() {
      this.doSubmitLoading = true;
      try {
        await this.$refs.vForm.validate();
        await this.api.user.bindMobile(this.vForm);
        this.$message.success('绑定成功');
        this.redirectProject();
      } catch (e) {
        console.error(e);
      }
      this.doSubmitLoading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.login-content {
  position: absolute;
  top: 168px;
  left: 480px;
  width: 354px;
}
.login-btn-box {
  margin-top: 50px;
}

input::-webkit-input-placeholder {
  font-size: 14px;
  color: #cacaca;
}

.login-btn {
  display: block;
  width: 100%;
  font-size: 16px;
  letter-spacing: 6px;
  background: linear-gradient(180deg, rgba(62, 144, 255, 1) 0%, rgba(21, 113, 238, 1) 100%);
  border-radius: 35px;
  border: 0;
  height: 50px;

  &:hover,
  &:focus {
    background: linear-gradient(180deg, rgba(62, 144, 255, 1) 0%, rgba(21, 113, 238, 1) 100%);
  }
}

/deep/ .form-control .el-input__inner {
  border-width: 0;
  border-radius: 40px;
  padding-left: 30px;
  height: 50px;
  background: #f6f6f6;
}

.form-group-code {
  position: relative;
}
.form-group-code .button-code {
  position: absolute;
  top: 0;
  right: 0;
  height: 48px;
  border-radius: 40px;
  width: 160px;
}
</style>
